var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgApiDocumentation = function SvgApiDocumentation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.701 46.878"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ApiDocumentation_svg__a",
    x1: 0.734,
    x2: 0.276,
    y1: 0.849,
    y2: 0.163,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb100"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.25 .75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2 17.283a8.429 8.429 0 0 1-8.42 8.42H9.42a8.42 8.42 0 1 1 0-16.84 8.17 8.17 0 0 1 .958.057 9.289 9.289 0 0 1 14.188-4.525 9.3 9.3 0 0 1 17.2 4.912c0 .184-.006.369-.019.557a8.415 8.415 0 0 1 4.45 7.419zM24.93 40.061v-3.723h-2.659v3.722h-9.749v2.659h22.157v-2.658z",
    style: {
      stroke: "#022256",
      strokeWidth: "1.5px",
      fill: "#ebf5ff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    style: {
      fill: "#fff"
    },
    transform: "translate(19.5 20.378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3 153.07a9.277 9.277 0 0 0 0-2.21l1.781-1.722a1.329 1.329 0 0 0 .227-1.621l-1.773-3.07a1.329 1.329 0 0 0-1.517-.613l-2.39.684a9.212 9.212 0 0 0-1.9-1.1l-.6-2.409a1.329 1.329 0 0 0-1.3-1.009h-3.545a1.329 1.329 0 0 0-1.29 1.007l-.6 2.409a9.205 9.205 0 0 0-1.9 1.1l-2.39-.684a1.329 1.329 0 0 0-1.517.613l-1.773 3.07a1.33 1.33 0 0 0 .227 1.621l1.781 1.722a9.277 9.277 0 0 0 0 2.21l-1.781 1.722a1.329 1.329 0 0 0-.227 1.62l1.773 3.07a1.329 1.329 0 0 0 1.517.613l2.39-.684a9.212 9.212 0 0 0 1.9 1.1l.6 2.409a1.329 1.329 0 0 0 1.29 1.007h3.545a1.329 1.329 0 0 0 1.29-1.007l.6-2.409a9.2 9.2 0 0 0 1.9-1.1l2.39.684a1.329 1.329 0 0 0 1.517-.613l1.773-3.07a1.33 1.33 0 0 0-.227-1.62zm-9.24 1.554a2.659 2.659 0 1 1 2.659-2.659 2.659 2.659 0 0 1-2.664 2.659z",
    style: {
      fill: "url(#ApiDocumentation_svg__a)",
      stroke: "#022256",
      strokeWidth: "1.5px"
    },
    transform: "translate(-36.455 -127.592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.977 166.323v5.318a1.329 1.329 0 0 1-1.329 1.329h-5.319A1.329 1.329 0 0 1 41 171.641v-5.318a1.329 1.329 0 0 1 1.329-1.329h5.318a1.329 1.329 0 0 1 1.33 1.329zm30.134 0v5.318a1.329 1.329 0 0 1-1.329 1.329h-5.318a1.329 1.329 0 0 1-1.329-1.329v-5.318a1.329 1.329 0 0 1 1.329-1.329h5.318a1.329 1.329 0 0 1 1.329 1.329z",
    style: {
      stroke: "#022256",
      strokeWidth: "1.5px",
      fill: "#ebf5ff"
    },
    transform: "translate(-36.455 -127.592)"
  })));
};
export default SvgApiDocumentation;